import React from "react";

import { Field } from "react-final-form";
import { TextFieldAdapter } from "@soqs/common";

const FraudIDNumberComponent = (props) => {
  let { required, label } = props;

  if (required === undefined) {
    required = false;
  }
  if (label === undefined) {
    label = "Identification Number";
  } 

  const isValid = (x) => {
    const re = /^[0-9]{13}$/;
    return (x || !required) &&
      (re.test(x) || (!required && (x === undefined || x?.length === 0)))
      ? undefined
      : " A valid " + label + " must be provided";
  };

  return (
    <Field
      name="idnumber"
      label={label}
      validate={isValid}
      component={TextFieldAdapter}
      subscription={{ touched: true, value: true, error: true }}
      inputProps={{ maxLength: 13 }}
      fullWidth
      required={required}
      {...props}
    />
  );
};

export default FraudIDNumberComponent;
